import {createAction} from 'redux-actions'

const action = baseName => createAction(`OVERVIEW_${baseName}`)

export const selectFactor = action('SELECT_FACTOR')
export const selectSubfactor = action('SELECT_SUBFACTOR')
export const selectTimeFrame = action('SELECT_TIME_FRAME')
export const selectGeography = action('SELECT_GEOGRAPHY')
